import { render, staticRenderFns } from "./Voice.vue?vue&type=template&id=57d14332&scoped=true&"
import script from "./Voice.vue?vue&type=script&lang=js&"
export * from "./Voice.vue?vue&type=script&lang=js&"
import style0 from "./Voice.vue?vue&type=style&index=0&id=57d14332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d14332",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
